import { useNavigate } from "react-router-dom"

export const useLink = () => {

  const navigate = useNavigate();
  return {
    navigate: (link?: string) => link ? () => navigate(link) : undefined
  }
}